import {
  DISABLED_TOGGLE_CONTAINER_STYLE,
  DISABLED_TOGGLE_SWITCH_STYLE,
  TOGGLE_CONTAINER_STYLE,
  TOGGLE_SWITCH_STYLE,
  TOGGLE_THEMES
} from '@/components/generic/ToggleSwitch/toggle-switch-config';

type ToggleSwitchProps = {
  containerClass?: string;
  toggled: boolean;
  handleToggle?: () => void;
  variant?: string;
  disabled?: boolean;
  'data-testid'?: string;
};

export const ToggleSwitch = ({
  containerClass = '',
  toggled: toggle,
  handleToggle,
  variant = TOGGLE_THEMES.DARK,
  disabled = false,
  'data-testid': dataTestId
}: ToggleSwitchProps) => {
  return (
    <div
      data-testid={dataTestId}
      className={`${toggle ? TOGGLE_CONTAINER_STYLE[variant] : DISABLED_TOGGLE_CONTAINER_STYLE} ${
        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
      } ${containerClass}`}
      onClick={() => {
        if (disabled) {
          return;
        }

        handleToggle?.();
      }}>
      <div
        className={`${toggle ? TOGGLE_SWITCH_STYLE[variant] : DISABLED_TOGGLE_SWITCH_STYLE} ${
          toggle && 'translate-x-[27px] md:translate-x-[23px]'
        }`}
      />
    </div>
  );
};
